import React from "react"
import PropTypes from "prop-types"
import '../styles/colors.css'
import GlobalStyles from "../styles/GlobalStyles"

import GeneralContextProvider from "../contexts/generalContext"
import PrivateContextProvider from "../areaprivada/privateContext"
import CookiesAlert from "./mini/cookiesAlert"
import ClientOnly from "../helpers/ClientOnly"

import Menu from "../components/menu"
// import Footer from "./footer"
import Loading from "../components/mini/loading"
import CtaModule from "../components/ctaModule"

const Layout = props => {
  const { children, pageContext } = props
  //zona general o área privada, para cambiar el fondo de color
  const zona =
    pageContext.pagina_tipo === "AREA_PRIVADA" ? "areaprivada" : "general"
  return (
    <>
      <GlobalStyles zona={zona} />
        <GeneralContextProvider>
          <PrivateContextProvider>
            <CtaModule isHidden={zona === 'areaprivada'} />
            <Menu alternatePages={pageContext?.langs} isHome={pageContext.template === "page_inicio"} />
            <main>{children}</main>
            <ClientOnly>
              <CookiesAlert />
              <Loading />
            </ClientOnly>
          </PrivateContextProvider>
        </GeneralContextProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
